export default __webpack_public_path__ + "static/media/play-video-instruction.858e6e68.svg";